import { BASE_API } from "../../configs/ConfigsConstants";

export async function getPpeUsersApi(id, token) {
  try {
    const url = `${BASE_API}/hrm/api/get_ppeuser/${id}/`;
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function addPpeUserApi(data, token) {
  try {
    const url = `${BASE_API}/hrm/api/save_ppeuser/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function updatePpeUserApi(data, token) {
  try {
    const url = `${BASE_API}/hrm/api/updates_ppeuser/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function deletePpeUserApi(id, token) {
  try {
    const url = `${BASE_API}/hrm/api/delete_ppeuser/${id}/`;
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}
